import instance from "../utils/network";
import { CommonResponse, PubTournament, ReservationResponse } from "./types";

export enum CurrentReservationType {
  SEED = "SEED",
  POINT = "POINT",
  NORMAL = "NORMAL",
}

export interface TournamentReservationRequest {
  reservationId: number;
  nickname: string;
  phoneNumber: string;
  userId?: number;
  route: string;
  type?: CurrentReservationType;
}
export interface UserReservationResponse {
  id: number;
  reservationId: number;
  createdAt: Date;
  updatedAt: Date;
  pubName: string;
  pubPhoneNumber: string;
  pubAddress: string;
  pubType: string;
  reservationImage: string;
  reservationCount: number;
  tournament: PubTournament;
  isCancel: boolean;
  isSpecial: boolean;
}

export interface CurrentReservationDto {
  nickname: string;
  id: number;
  userId: number;
}

export function registerReservation(
  data: TournamentReservationRequest
): Promise<CommonResponse> {
  return instance.post("/nest/reservation/register", data);
}

export function getReservation(id: number): Promise<ReservationResponse> {
  return instance.get("/nest/reservation/detail/" + id);
}

export function getCurrentReservations(
  id: number
): Promise<CurrentReservationDto[]> {
  return instance.get(`/nest/reservation/current/${id}`);
}

export function getUserReservationList(
  year: number,
  month: number
): Promise<UserReservationResponse[]> {
  return instance.get(`/nest/reservation/my?year=${year}&month=${month}`);
}

export function reservationCancel(id: number): Promise<any> {
  return instance.delete(`/nest/reservation/cancel/${id}`);
}
